import React, { useContext, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import is from "is_js";
import AppContext from "context/Context";
import CRMRoutes from "routes";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.min.css";
import "modules/whatsapp_analytics/WhatsAppAnalytics.css";
import { ToastContainer } from 'react-toastify';
import { ConfigProvider } from 'antd';

const App = () => {
  const HTMLClassList = document.getElementsByTagName("html")[0].classList;
  const {
    config: { navbarPosition },
  } = useContext(AppContext);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add("windows");
    }
    if (is.chrome()) {
      HTMLClassList.add("chrome");
    }
    if (is.firefox()) {
      HTMLClassList.add("firefox");
    }
    if (is.safari()) {
      HTMLClassList.add("safari");
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === "double-top") {
      HTMLClassList.add("double-top-nav-layout");
    }
    return () => HTMLClassList.remove("double-top-nav-layout");
  }, [navbarPosition]);
  useEffect(() => {
    const rootElement = document.documentElement;
    rootElement.style.fontSize = ".8rem";
  }, []);
  return (
	<>
	 <ToastContainer />
    <ConfigProvider
      theme={{
        token: {
          zIndexPopupBase: 2000,
        },
      }}
      getPopupContainer={() => document.body}
    >
      <Router basename={process.env.PUBLIC_URL}>
        {/* Using CRMRoutes (v1) for first release - myTickets and Configure routes are working */}
        {/* CRMRoutesV2 can be implemented in next release */}
        <CRMRoutes />
      </Router>
    </ConfigProvider>
	</>
  );
};

export default App;
